"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCurrentOwnerIdFromCache = fetchCurrentOwnerIdFromCache;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = require("../actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _Identifiable = require("customer-data-objects/protocol/Identifiable");

var _immutable = require("immutable");

var _isNumber = _interopRequireDefault(require("transmute/isNumber"));

var _LocalSettings = require("crm_data/settings/LocalSettings");

var _OwnersAPI = require("./OwnersAPI");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _q = _interopRequireDefault(require("q"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

function fetchCurrentOwnerIdFromCache() {
  return (0, _userInfo.default)().then(function (info) {
    var key = "OID:" + info.user.user_id + ":" + _hubspot.default.get();

    var cachedId = (0, _LocalSettings.getFrom)(localStorage, key);

    if ((0, _isNumber.default)(cachedId) && cachedId > 0) {
      return _q.default.Promise.resolve(cachedId);
    }

    return (0, _OwnersAPI.fetchCurrentOwner)().then(function (owner) {
      if (!owner) {
        (0, _Dispatch.dispatchImmediate)(_ActionTypes.OWNERS_FETCH_SUCCEEDED, (0, _immutable.Map)({
          '-1': null
        }));
        return -1;
      }

      var ownerId = (0, _Identifiable.getId)(owner);
      (0, _LocalSettings.setFrom)(localStorage, key, ownerId);
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.OWNERS_FETCH_SUCCEEDED, (0, _immutable.Map)((0, _defineProperty2.default)({}, ownerId, owner)));
      return ownerId;
    });
  });
}